export const numberToString = (v: number) => {
	if (isNaN(v)) {
		return '0';
	}
	return v.toString();
};
